/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FinishRecurrentTaskInput = {
  count: number;
  recurrentTaskId: string;
};

export type GetRecurrentTasksInput = {
  type?: RecurrentTaskType | null | undefined;
};

export type RecurrentTaskStatus = "DONE" | "OPEN";

export type RecurrentTaskType = "BIKE_BATTERY_COUNT";

export type GetRecurrentTasksForHubQueryVariables = Exact<{
  input?: Types.GetRecurrentTasksInput | null | undefined;
}>;

export type GetRecurrentTasksForHubQuery = {
  getRecurrentTasksForHub: {
    recurrentTasks: Array<{
      id: string;
      type: Types.RecurrentTaskType;
      hubSlug: string;
      status: Types.RecurrentTaskStatus;
      startDate: string;
      dueDate: string;
      createdAt: string;
      updatedAt: string | null;
      updatedBy: string | null;
      customAttributes: { count: number };
    }>;
  };
};

export type FinishRecurrentTaskMutationVariables = Exact<{
  input: Types.FinishRecurrentTaskInput;
}>;

export type FinishRecurrentTaskMutation = { finishRecurrentTask: { success: boolean } };

export const GetRecurrentTasksForHubDocument = gql`
  query GetRecurrentTasksForHub($input: GetRecurrentTasksInput) {
    getRecurrentTasksForHub(input: $input) {
      recurrentTasks {
        id
        type
        hubSlug
        status
        startDate
        dueDate
        createdAt
        updatedAt
        updatedBy
        customAttributes {
          count
        }
      }
    }
  }
`;

/**
 * __useGetRecurrentTasksForHubQuery__
 *
 * To run a query within a React component, call `useGetRecurrentTasksForHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurrentTasksForHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurrentTasksForHubQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRecurrentTasksForHubQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRecurrentTasksForHubQuery,
    GetRecurrentTasksForHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRecurrentTasksForHubQuery, GetRecurrentTasksForHubQueryVariables>(
    GetRecurrentTasksForHubDocument,
    options,
  );
}
export function useGetRecurrentTasksForHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecurrentTasksForHubQuery,
    GetRecurrentTasksForHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRecurrentTasksForHubQuery, GetRecurrentTasksForHubQueryVariables>(
    GetRecurrentTasksForHubDocument,
    options,
  );
}
// @ts-ignore
export function useGetRecurrentTasksForHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecurrentTasksForHubQuery,
    GetRecurrentTasksForHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRecurrentTasksForHubQuery,
  GetRecurrentTasksForHubQueryVariables
>;
export function useGetRecurrentTasksForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecurrentTasksForHubQuery,
        GetRecurrentTasksForHubQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRecurrentTasksForHubQuery | undefined,
  GetRecurrentTasksForHubQueryVariables
>;
export function useGetRecurrentTasksForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecurrentTasksForHubQuery,
        GetRecurrentTasksForHubQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecurrentTasksForHubQuery,
    GetRecurrentTasksForHubQueryVariables
  >(GetRecurrentTasksForHubDocument, options);
}
export type GetRecurrentTasksForHubQueryHookResult = ReturnType<
  typeof useGetRecurrentTasksForHubQuery
>;
export type GetRecurrentTasksForHubLazyQueryHookResult = ReturnType<
  typeof useGetRecurrentTasksForHubLazyQuery
>;
export type GetRecurrentTasksForHubSuspenseQueryHookResult = ReturnType<
  typeof useGetRecurrentTasksForHubSuspenseQuery
>;
export type GetRecurrentTasksForHubQueryResult = Apollo.QueryResult<
  GetRecurrentTasksForHubQuery,
  GetRecurrentTasksForHubQueryVariables
>;
export const FinishRecurrentTaskDocument = gql`
  mutation FinishRecurrentTask($input: FinishRecurrentTaskInput!) {
    finishRecurrentTask(input: $input) {
      success
    }
  }
`;
export type FinishRecurrentTaskMutationFn = Apollo.MutationFunction<
  FinishRecurrentTaskMutation,
  FinishRecurrentTaskMutationVariables
>;

/**
 * __useFinishRecurrentTaskMutation__
 *
 * To run a mutation, you first call `useFinishRecurrentTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishRecurrentTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishRecurrentTaskMutation, { data, loading, error }] = useFinishRecurrentTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishRecurrentTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishRecurrentTaskMutation,
    FinishRecurrentTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FinishRecurrentTaskMutation, FinishRecurrentTaskMutationVariables>(
    FinishRecurrentTaskDocument,
    options,
  );
}
export type FinishRecurrentTaskMutationHookResult = ReturnType<
  typeof useFinishRecurrentTaskMutation
>;
export type FinishRecurrentTaskMutationResult = Apollo.MutationResult<FinishRecurrentTaskMutation>;
export type FinishRecurrentTaskMutationOptions = Apollo.BaseMutationOptions<
  FinishRecurrentTaskMutation,
  FinishRecurrentTaskMutationVariables
>;
